import { clientApi } from '../../configuration';
import getCRUDHooks from '../../utils/services/getCRUDHooks';

type FindLinksParams = {
  userId: number;
  filters?: Record<any, any>;
  queryParams?: {
    source?: 'admindashboard' | 'coachdashboard' | 'studentdashboard';
  };
};

const { useFind: useUserLinks } = getCRUDHooks({
  entityName: 'useUserLinks',
  find: ({ userId, filters, queryParams }: FindLinksParams) =>
    clientApi
      .getOCClient()
      .helpers.user.users.id(userId)
      .links.find({
        ...filters,
        ...queryParams,
      }),
});

// eslint-disable-next-line import/prefer-default-export
export { useUserLinks };
